const validateName = (data) => {
  const validationOutput = {};

  if (Object.prototype.hasOwnProperty.call(data, 'name')) {
    if (data.name === '') {
      validationOutput.nameValid = 'invalid';
    } else {
      validationOutput.nameValid = 'valid';
    }
  }

  return validationOutput;
};

const validateEmail = (data) => {
  const validationOutput = {};

  if (Object.prototype.hasOwnProperty.call(data, 'email')) {
    const emailRegEx = /\S+@\S+\.\S+/;
    if (!emailRegEx.test(data.email)) {
      validationOutput.emailValid = 'invalid';
    } else {
      validationOutput.emailValid = 'valid';
    }
  }

  return validationOutput;
};

const validateContent = (data) => {
  const validationOutput = {};

  if (Object.prototype.hasOwnProperty.call(data, 'content')) {
    if (data.content === '' || data.content.length < 50) {
      validationOutput.contentValid = 'invalid';
    } else {
      validationOutput.contentValid = 'valid';
    }
  }

  return validationOutput;
};


export const validateForm = (data) => {
  let validationOutput = {};

  const nameValidationOutput = validateName(data, validationOutput);
  validationOutput = Object.assign(validationOutput, nameValidationOutput);

  const emailValidationOutput = validateEmail(data, validationOutput);
  validationOutput = Object.assign(validationOutput, emailValidationOutput);

  const contentValidationOutput = validateContent(data, validationOutput);
  validationOutput = Object.assign(validationOutput, contentValidationOutput);

  return validationOutput;
};



// WEBPACK FOOTER //
// ./src/components/Contact/helpers.js